import React from 'react';
import { Link } from 'react-router-dom';
import SamsaraLogo from '../assets/Samsara_Logo.svg';

const LandingPage: React.FC = () => {
    return (
        <div className="min-h-screen flex flex-col">
            <div className="inline-block px-8 py-2 rounded-lg">
            <div className="flex-1 flex flex-col justify-center items-center text-center px-4 py-12 md:py-24">
                <img
                    src={SamsaraLogo}
                    alt="Samsara Logo"
                    className="w-32 h-32 mb-8"
                />
                <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold tracking-tighter mb-6">
                        <span className="text-accent" style={{
                            color: '#3F013D',
                            textShadow: '1px 1px 0 #ae4094, -1px -1px 0 #000, 0px 1px 0 #ae4094, 1px 0px 0 #ae4094, 0px -1px 0 #000, -1px 0px 0 #000'
                        }}>Samsara Capital Partners</span>

                </h1>
                <p className="text-xl md:text-2xl max-w-3xl mb-12 text-white">
                    A Private Equity firm speciallized in acquiring and rolling legacy companies, updating their workflows and easing their transition into the future.
                </p>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl w-full mt-8">
                    <div className="bg-gray-900 bg-opacity-50 backdrop-blur p-8 rounded-lg transform transition-all hover:scale-105 hover:bg-opacity-70">
                        <h2 className="text-2xl font-bold mb-4">Our Thesis</h2>
                        <p className="text-gray-300 mb-4">
                            We build compounding value by acquiring operationally strong businesses and integrating AI workflows, shared infrastructure, and cross-portfolio synergies across sectors.
                        </p>
                            <Link to="/thesis" className="text-accent-light hover:underline">
                            Learn more →
                        </Link>
                    </div>

                    <div className="bg-gray-900 bg-opacity-50 backdrop-blur p-8 rounded-lg transform transition-all hover:scale-105 hover:bg-opacity-70">
                        <h2 className="text-2xl font-bold mb-4">Latest Insights</h2>
                        <p className="text-gray-300 mb-4">
                            Explore our latest thoughts on market trends, technology, and investment opportunities.
                        </p>
                            <Link to="/augury" className="text-accent-light hover:underline">
                            Read our blog →
                        </Link>
                    </div>
                </div>
                </div>
            </div>

            <div className="w-full py-12 bg-accent">
                <div className="max-w-6xl mx-auto px-4">
                    <div className="flex flex-col md:flex-row justify-between items-center">
                        <div className="mb-8 md:mb-0">
                            <h2 className="text-3xl font-bold mb-4">Ready to partner?</h2>
                            <p className="text-gray-200 max-w-lg">
                                We're always looking for exceptional opportunities and partners.
                            </p>
                        </div>
                        <Link
                            to="/about"
                            className="py-3 px-8 bg-white text-accent font-bold rounded-lg hover:bg-gray-200 transition-colors"
                        >
                            Get in touch
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LandingPage;
